module.exports = __webpack_public_path__ + "static/media/XMLID_16_.60c248a5.svg";